var PaymentGatewayTesterConstants = {

  CHANGE_EVENT:         'changeEvent',
  CANCEL_GATEWAY:       'cancelGateway',
  DELETE_GATEWAY:       'deleteGateway',
  INIT:                 'init',
  SET_GATEWAY:          'setGateway',
  SET_GATEWAY_DEFAULT:  'setGatewayDefault',
  SET_GATEWAY_LIVE: 'setGatewayLive',
  NEW_GATEWAY:          'newGateway',
  UPDATE_GATEWAY_NAME:  'updateGatewayName',

};

export default PaymentGatewayTesterConstants
